export const ADDTOCART = "cart/add";
export const REMOVEFROMCART = "cart/remove";